module.exports = __webpack_public_path__ + "img/activity-1.2255eb28.png";